var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"design-preview",attrs:{"aria-hidden":"true"}},_vm._l((4),function(row){return _c('i',{key:row,staticClass:"dp-line"},[_c('b')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }